<template>
  <div id="portfolio">
    <div class="container">
      <div class="row">

        <div class="col-xs-12">
          <h1>portfolio</h1>
        </div>


        <div class="col-xs-12">
          <ul class="project-types">
            <project-type v-for="type in types" :type="type"></project-type>
          </ul>
        </div>


        <div class="col-xs-12 col-md-10 col-md-offset-1">
          <div class="row">

            <div class="grid">
              <project-preview v-for="project in projects" :project="project" v-bind:class="'grid-item'"></project-preview>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Isotope from 'isotope-layout';
  import Stash from 'services/Stash';
  import ProjectType from 'components/ProjectType';
  import ProjectPreview from 'components/ProjectPreview';

  const createGrid = () => new Isotope('.grid', {
    itemSelector: '.grid-item',
    layoutMode:   'fitRows',
    fitRows:      {
      gutter: 10,
    },
  });

  export default {

    components: { ProjectType, ProjectPreview },

    data() {
      return {
        state: Stash.state,
        iso:   null,
      };
    },

    mounted() {
      this.iso = createGrid();

      if (this.type !== 'ALL') {
        this.arrange(this.type);
      }
    },

    methods: {

      sortProjectsAlpha(a, b) {
        if (a.name < b.name) {
          return -1;
        } else if (a.name > b.name) {
          return 1;
        }
        return 0;
      },

      arrange() {
        this.iso.arrange({ filter: `.${this.type.toLowerCase()}` });
      },

    },

    computed: {

      projects() {
        return this.state.projects.sort(this.sortProjectsAlpha);
      },

      type() {
        return this.state.type;
      },

      types() {
        return this.state.types;
      },

      firstSix() {
        return this.projects.slice(0, 6);
      },

    },

    watch: {

      type(val) {
        this.arrange(val);
      },

    },

  };
</script>

<style scoped>
  #portfolio {
    padding: 75px 0;
    color: #638E9C;
  }

  h1 {
    font-size: 50px;
    margin-top: 40px;
    text-align: center;
    text-transform: uppercase;
  }

  .project-types {
    margin: 40px 0;
    padding-left: 0;
    text-align: center;
    list-style-type: none;
  }

  .grid-item {
    width: 32%;
    height: 300px;
  }

  .grid-item {
    font-size: 16px;
  }

  @media (max-width: 767px) {
    h1 {
      margin-top: 0;
    }

    .grid-item {
      width: 42%;
      margin-left: 5%;
      height: 275px;
    }

    .project-types {
      margin-bottom: 0;
    }
  }

  @media (max-width: 575px) {
    .grid-item {
      width: 100%;
      display: block;
      height: 250px;
    }

    .preview {
      padding: 0;
      margin: 20px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// Portfolio.vue?664c808c